import React from "react"
import { useTranslation } from "react-i18next"

import { Button, ButtonVariant } from "shared/ui/buttons/Button"
import { IconName } from "shared/ui/icon/__generated__/IconName"

import "./styles/_product-configurator-mode-select.scss"

export interface ProductConfiguratorModeSelectProps {
  image: React.ReactNode

  isConfigurationAvailable: boolean
  isExternalDimensioningAvailable: boolean

  onConfigurationSelect: () => void
  onDimensioningSelect: () => void
}

export const ProductConfiguratorModeSelect = React.memo(
  ({
    image,
    isConfigurationAvailable,
    isExternalDimensioningAvailable,
    onConfigurationSelect,
    onDimensioningSelect
  }: ProductConfiguratorModeSelectProps) => {
    const { t } = useTranslation()

    return (
      <div className="product-configurator-mode-select">
        <div className="product-configurator-mode-select__image">{image}</div>
        <div className="product-configurator-mode-select__question">
          {t("Product.Configuration.HowToStart")}
        </div>

        <p className="product-configurator-mode-select__description">
          {t("Product.Configuration.HowToStartDescription")}
        </p>
        <div className="product-configurator-mode-select__buttons button-group">
          <Button
            variant={ButtonVariant.PRIMARY}
            id="product-config-mode-select-configuration-button"
            icon={IconName.CONFIGURATION}
            onClick={onConfigurationSelect}
            disabled={!isConfigurationAvailable}
          >
            {t("Product.Configuration.Configure")}
          </Button>
          <Button
            variant={ButtonVariant.PRIMARY}
            id="product-config-mode-select-dimensioning-button"
            icon={IconName.DIMENSIONING}
            onClick={onDimensioningSelect}
            disabled={!isExternalDimensioningAvailable}
          >
            {t("Product.Configuration.Dimension")}
          </Button>
        </div>
      </div>
    )
  }
)
